<p-toast position="top-right"></p-toast>
<p-confirmDialog #cd [style]="{width: '600px'}">
  <p-footer>
    <button type="button" pButton accesskey="y" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Delete" (click)="cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>

<div class="manage-roster-code-page">
  <p-toolbar>
    <div class="p-toolbar-group-left">
      <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>
      <span style="padding-top:2px;">
        <button pButton type="button" 
                class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
                icon="pi pi-fw pi-refresh" 
                (click)="loadData()"></button>

        <!-- Display only on bigger than md screens-->
        <span class="p-d-none p-d-md-inline">
          <button pButton type="button" 
                  class="p-button p-button-text" 
                  label="Add Roster Code" 
                  icon="pi-fw fas fa-plus-circle"
                  (click)="addRosterCode()"></button>
        </span>

        <!-- Display only on smaller than md screens-->
        <span class="p-d-md-none">
          <button pButton type="button" 
                  class="p-button-rounded"  
                  icon="pi-fw fas fa-plus-circle"
                  (click)="addRosterCode()"></button>
        </span>

      </span>
    </div>

    <div class="p-toolbar-group-right">
      <i class="pi-fw far fa-bell p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon" pBadge 
         severity="info"
         pTooltip="Total Number of Links: {{rosterCodes.length}}"
         value="{{rosterCodes.length}}"></i>
    </div>
  </p-toolbar>
  <p-splitter class="manage-roster-code-splitter" styleClass="manage-roster-code-splitter-root" [layout]="smallScreen ? 'vertical' : 'horizontal'" [panelSizes]="[70,30]" [gutterSize]="8">
    <ng-template pTemplate>
      <div style="height: 100%;">
        <ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
                    size="default"
                    color="#2f9cf2"
                    type="line-scale-pulse-out"
                    [name]="spinnerName"
                    [fullScreen]="false">

          <p style="color:white" >Loading roster code... </p>
        </ngx-spinner>

        <ag-grid-angular
            *ngIf="rosterCodes.length > 0"
            style="width: 100%; height:100%;"
            class="ag-theme-alpine"
            [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }"
            [gridOptions]="gridOptions"
            [context]="context"
            [rowData]="rosterCodes"
            [columnDefs]="gridHeaders"
            [enterNavigatesVertically]="true"  
            [enterNavigatesVerticallyAfterEdit]="true"        
            (gridReady)="onGridReady($event)"></ag-grid-angular>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <p-messages severity="warn">
        <ng-template pTemplate>
          <p-panel header="Can be used in timesheet">
            <div class="p-pt-1">
              <p>
                <i class="fas fa-lightbulb" style="color:yellow;font-weight:bold;font-size:1.5rem"></i>
                Roster codes with this checked will be displayed in <strong>Timesheet -> Enter Timesheet -> Work Shift</strong> dropdown list.
              </p>
            </div>
          </p-panel>          
        </ng-template>
      </p-messages>
      
      <p-messages severity="warn">
        <ng-template pTemplate>
          <p-panel header="Can be used in payroll breakdown rule">
            <div class="p-pt-1">
              <p>
                <i class="fas fa-lightbulb" style="color:yellow;font-weight:bold;font-size:1.5rem"></i>
                Roster codes with this checked will be displayed in <strong>Settings -> Manage Payroll Timesheet Rules -> Roster Code</strong> dropdown list.
              </p>
            </div>
          </p-panel>          
        </ng-template>
      </p-messages>
    </ng-template>
  </p-splitter>
</div>
